/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FotaApiService {
  private history = [];
  public img = '';

  private APIService = environment.serviceUrl + 'fota';

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  getFotaList(currentPage, pageSize, search): Observable<any> {
    return this.http.get(
      this.APIService +
        '/getbatch?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search
    );
  }

  getFotaDeviceDetailByImei(imei): Observable<any> {
    return this.http.get(this.APIService + '/getDetailByImei?imei=' + imei);
  }

  uploadFotaBatch(file: File, payload): Observable<any> {
    const formData = new FormData();

    // Append fields to the FormData object
    formData.append('file', file);
    formData.append('name', payload.name);
    formData.append('desc', payload.desc);
    formData.append('type', payload.type);
    formData.append('fotaType', payload.fotaType);
    formData.append('userId', payload.userId);

    // Make the POST request
    return this.http.post(this.APIService + '/upload', formData);
  }

  fetchfotaBatchdetails(id): Observable<any> {
    return this.http.get(this.APIService + '/fotabatchdata?fotaBatchId=' + id);
  }

  exportfotaBatch(id): Observable<any> {
    return this.http.get(this.APIService + '/exportBatch?fotaBatchId=' + id);
  }

  getFotaDeviceList(
    id,
    status,
    currentPage,
    pageSize,
    search
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        '/getbatchdevices?fotaBatchId=' +
        id +
        '&status=' +
        status +
        '&page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search
    );
  }

  startFota(id): Observable<any> {
    return this.http.get(this.APIService + '/startfota?fotaBatchId=' + id);
  }

  abortFota(id): Observable<any> {
    return this.http.get(this.APIService + '/abortfota?deviceId=' + id);
  }

  deleteBatch(id): Observable<any> {
    return this.http.get(this.APIService + '/deletebatch?fotaBatchId=' + id);
  }

  getLoginPacketList(currentPage, pageSize, imei): Observable<any> {
    return this.http.get(
      this.APIService +
        '/getdevicepackets?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&imei=' +
        imei
    );
  }

  getDeviceDetails(imei): Observable<any> {
    return this.http.get(
      this.APIService + '/getJoinedDeviceDetails?imei=' + imei
    );
  }

  startManualFota(payload): Observable<any> {
    return this.http.post(this.APIService + '/startManualFota', payload);
  }
}
